import { useNavigate } from 'react-router-dom';
import { useState } from 'react'
import swal from 'sweetalert'
import { useCreateSeatMutation } from '../../Features/seatsSlice';
import LoadingBar from "react-top-loading-bar";
import { useIsOnline } from 'react-use-is-online';

function CreateSeatView() {
    const navigate = useNavigate();
    const [progress, setProgress] = useState(0);
    const { isOnline } = useIsOnline();

    const [input, setInput] = useState({
        number: '',
    })

    const [errors, setErrors] = useState({
        number: '',
    })

    const [createSeat] = useCreateSeatMutation();

    const handleChange = (e)=>{
        setInput({...input, [e.target.name]: e.target.value})
    }

    const handleSubmit = async(e)=>{
        if(!isOnline){
            return swal("No Internet connection",'Please check Internet connection and try again'); 
        }
        e.preventDefault();
        try {
            setProgress(80)
            const resp = await createSeat(input).unwrap()
            if(resp.hasOwnProperty('success') == true){
                setProgress(100)
                return navigate(-1);
            }
        } catch (err) {
            setProgress(100)
            if(err.data.hasOwnProperty('errors') == true){
                setErrors({...errors, number: err.data.errors.number})
            }else if (err.data.hasOwnProperty('error') == true){
                setInput({...input, errorMassage: err.data.error})
            }
        }          
    }

    const back = ()=> {
        if(!isOnline){
            return swal("No Internet connection",'Please check Internet connection and try again'); 
        }
        setProgress(80)
        navigate(-1)
    };

    return (   
            <div className="md:w-2/5 mb-12">
                <LoadingBar
                color="#14b8a6"
                height="4px"
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
                />
                <div class="bg-white shadow-md rounded-md flex flex-col justify-center">
                    <div class="p-3">
                        <form onSubmit={handleSubmit} autoComplete="off" >
                            <div class="divide-y divide-gray-200">
                                <div class="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                                <div class="flex flex-col">
                                    <div class="col-span-6 sm:col-span-3 p-2">
                                        <label for="number" class="block text-xs text-gray-500">Seat No.</label>
                                        <input 
                                            class="mt-1 p-2 outline-none focus:border-green-500 block w-full text-gray-700 text-sm  border-b border-gray-300"
                                            type="text"
                                            name="number" 
                                            id="number" 
                                            value={input.number}
                                            onChange={handleChange}
                                        />
                                        <p className="block text-sm font-medium text-red-800 p-0 m-0">{errors.number}</p>
                                    </div>
                                </div>
                                </div>
                                <div class="pt-4 flex items-end space-x-4">
                                    <div onClick={back} class="flex cursor-pointer hover:bg-gray-50 justify-center items-center w-full text-gray-900 px-4 py-3 rounded-md focus:outline-none">
                                        Cancel
                                    </div>
                                    <button type='submit' class="bg-green-500 flex justify-center items-center w-full text-white px-4 py-3 rounded-sm hover:shadow-md focus:outline-none">Save</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )

}

export default CreateSeatView;
